export default {
  async actionGetAllNotification({ rootState, commit }) {
    const page = 1;
    const response = await this.$services._core.notification().getAllNotification({
      page
    });

    const result = {
      results     : response.data.results,
      totalCount  : parseInt(response.data.totalCount) || 0,
      totalUnread : parseInt(response.data.totalUnread) || 0,
      page
    };


    commit('SET_NOTIFICATION', result);
  },
  async actionGetAllNotificationByPage({ rootState, commit }) {
    const { notification } = rootState._core;
    const page = notification.page + 1;
    const old = notification.data;

    const response = await this.$services._core.notification().getAllNotification({
      page
    });

    const result = {
      results     : [...old, ...response.data.results],
      totalCount  : parseInt(response.data.totalCount) || 0,
      totalUnread : parseInt(response.data.totalUnread) || 0,
      page
    };

    commit('SET_NOTIFICATION', result);
  },
  async actionReadNotification({ rootState, commit }, id) {
    const { notification } = rootState._core;
    const results = JSON.parse(JSON.stringify(notification.data));

    await this.$services._core.notification().updateNotificationRecipients(id, { isRead: true });


    results.map(item => {
      if (item.recipientId === id) {
        item.isRead = true;
      };
      return item;
    });
  },
  async actionReadAllNotification({ rootState, commit }) {
    await this.$services._core.notification().updateSetReadAllNotification();

    const { notification } = rootState._core;
    const results = notification.data;

    commit('SET_NOTIFICATION', { results, totalUnread: 0 });
  }
};
